import { render, staticRenderFns } from "./Ordered.vue?vue&type=template&id=66a0944e&scoped=true"
import script from "./Ordered.vue?vue&type=script&lang=js"
export * from "./Ordered.vue?vue&type=script&lang=js"
import style0 from "./Ordered.vue?vue&type=style&index=0&id=66a0944e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0944e",
  null
  
)

export default component.exports